var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#D6E1F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.998,
    cy: 36,
    r: 25,
    fill: "#00338D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.1101 48.5C35.9553 48.5 35.8006 48.4645 35.6609 48.3921L31.1595 46.062C29.8822 45.4001 28.883 44.6573 28.1028 43.7919C26.3951 41.8994 25.445 39.47 25.4299 36.9499L25.3771 28.6553C25.3708 27.698 25.9887 26.8388 26.9123 26.5152L35.1776 23.6335C35.6684 23.4582 36.2158 23.4558 36.7154 23.6249L45.0122 26.4086C45.9409 26.7187 46.5689 27.5718 46.5739 28.5279L46.6268 36.8285C46.6431 39.345 45.7257 41.7842 44.0445 43.6976C43.2731 44.5752 42.2827 45.329 41.018 46.0032L36.5569 48.386C36.4184 48.4608 36.2649 48.4988 36.1101 48.5Z",
    fill: "#D6E1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.151 38.9011C34.9094 38.9024 34.6677 38.8153 34.4815 38.6364L32.0855 36.332C31.7155 35.9741 31.7117 35.3931 32.0779 35.0327C32.4441 34.6711 33.0419 34.6674 33.4131 35.0241L35.1371 36.6813L39.3465 32.531C39.714 32.1694 40.3118 32.1657 40.6817 32.5224C41.053 32.8803 41.0567 33.4625 40.6905 33.8217L35.8167 38.6278C35.6329 38.8092 35.3926 38.8999 35.151 38.9011Z",
    fill: "#D6E1F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.e686f0888b323212da106715c3f36a3c.svg";
export { ForwardRef as ReactComponent };